<i18n>
{
    "en_US": {
        "label": "Email",
        "pending": "Waiting for a reply",
        "available": "Email is available",
        "not-available": "Email is not available",
        "not-good": "Email is not valid"
    },
    "fr_FR": {
        "label": "Email",
        "pending": "En attente d'une réponse",
        "available": "Email disponible",
        "not-available": "Email non disponible",
        "not-good": "L'email est invalide"
    }
}
</i18n>

<template>
    <div class="input-group mb-3 bmd-form-group">
        <label for="inputEmail" class="bmd-label-floating" v-text="$t('label')"></label>
        <input id="inputEmail" type="email" class="form-control bmb-control" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" v-bind:disabled="disabled" required />
        <div class="input-group-append" v-bind:class="{active: value && value.length > 0}">
            <a class="input-group-text" id="basic-addon2">
                <i v-if="!pending.email_availability && available" class="fa fa-check text-success" v-bind:title="$t('available')"></i>
                <i v-if="!pending.email_availability && wrong" class="fa fa-times text-danger" v-bind:title="$t('not-good')"></i>
                <i v-if="!pending.email_availability && !wrong && !available" class="fa fa-times text-danger" v-bind:title="$t('not-available')"></i>
                <i v-if="pending.email_availability" class="fas fa-sync-alt text-waiting rotating" v-bind:title="$t('pending')"></i>
            </a>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";

    export default {
        name: "CheckEmailAvailability",
        props: {
            value: String,
            escaped: String,
            disabled: Boolean
        },
        data: function() {
            return {
                available: false,
                wrong: false
            };
        },
        watch: {
            value: function(val) {
                // System can consider one email as beeing the good one...
                if (val === this.escaped && this.escaped) {
                    this.available = true;
                    this.wrong = false;
                    return;
                }

                this.available = false;
                this.wrong = false;

                if (!this.validateEmail(this.value)) {
                    this.wrong = true;
                    return;
                }

                this.emailAvailability({
                    email: val
                })
                    .then(function(response) {
                        this.$Progress.finish();
                        this.available = response.data.available;
                    }.bind(this))
                    .catch(function() {});
            }
        },
        computed: {
            ...mapState("user", ["pending"]),
        },
        methods: {
            validateEmail: function(email) {
                // eslint-disable-next-line
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            ...mapActions("user", ["emailAvailability"])
        }
    }
</script>

<style scoped>
    input {
        border-right: 0;
    }
    label {
        font-weight: bold;
        font-size: 14px;
    }
    .input-group-append {
        display: none;
    }
    .input-group-append.active {
        display: flex;
    }
    a {
        cursor: pointer;
        background-color: #fff;
        border-left: 0;
    }
    a .fa-check {
        display: inline-block;
        padding-left: 5px;
    }
    a .fa-sync-alt {
        display: inline-block;
        margin-left: 5px;
        color: #247cf0;
    }
    a .fa-times {
        display: inline-block;
        padding-left: 10px;
    }
    i {
        color: #949ba1;
    }

    /* Rotating animation */
    @-webkit-keyframes rotating /* Safari and Chrome */ {
        from {
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes rotating {
        from {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    .rotating {
        -webkit-animation: rotating 2s linear infinite;
        -moz-animation: rotating 2s linear infinite;
        -ms-animation: rotating 2s linear infinite;
        -o-animation: rotating 2s linear infinite;
        animation: rotating 2s linear infinite;
    }
</style>